import React from 'react'
import './CheckOut.scss'

const CheckOutHeader = () => {
  return (
    <div className='checkoutheaderclass mt-4'>
        <div id='checkoutheader'><h1>CHECK OUT</h1></div>
    </div>
  )
}

export default CheckOutHeader